import React from "react";
import AppFooterWeb from "../../components/AppFooterWeb";

export class PhotosGallery extends React.Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <div className="banner-section">
          <div className="collections-blank"></div>
          <div className="photos-gallery">
            <div className="photosgallery-section">
              <img
                src={require("../../assets/images/About.png")}
                className="gallery-img"
                alt="photos-gallery"
              />
              <img
                src={require("../../assets/images/desktop-banner1.png")}
                className="gallery-img"
                alt="photos-gallery"
              />
              <img
                src={require("../../assets/images/ess-300.png")}
                className="gallery-img"
                alt="photos-gallery"
              />
              <img
                src={require("../../assets/images/guitar.png")}
                className="gallery-img"
                alt="photos-gallery"
              />
              <img
                src={require("../../assets/images/gogos.png")}
                className="gallery-img"
                alt="photos-gallery"
              />
            </div>
          </div>
        </div>
        <AppFooterWeb
          pathName={this.props.location?.pathname}
          history={this.props.history}
        />
      </>
    );
  }
}

export default PhotosGallery;
